const SAVE_GOOGLE_DATA = 'SAVE_GOOGLE_DATA';
const GET_GOOGLE_DATA  = 'GET_GOOGLE_DATA';
const SET_GOOGLE_DATA  = 'SET_GOOGLE_DATA';
const SELECT_TAB = 'SELECT_TAB';
const REVOKE_GOOGLE_ACCESS = 'REVOKE_GOOGLE_ACCESS';

const saveGoogleData = data => {
    return {
        type: SAVE_GOOGLE_DATA,
        data
    };
}

const getGoogleData = () => {
    return {
        type: GET_GOOGLE_DATA
    };
}

const setGoogleData = data => {
    return {
        type: SET_GOOGLE_DATA,
        data
    };
}

const selectTab = tab => {
    return {
        type: SELECT_TAB,
        tab
    }
}

const revokeGoogleAccess = () => {
    return {
        type: REVOKE_GOOGLE_ACCESS
    };
}


export default {
    types: {
        SAVE_GOOGLE_DATA,
        GET_GOOGLE_DATA,
        SET_GOOGLE_DATA,
        SELECT_TAB,
        REVOKE_GOOGLE_ACCESS
    },    
    actions: {
        saveGoogleData,
        getGoogleData,
        setGoogleData,
        selectTab,
        revokeGoogleAccess
    }
}